var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-product g-flex g-w-full g-items-center g-cursor-pointer"},[_c('g-icon',{staticClass:"plus",attrs:{"name":"plus"}}),_vm._v(" "),_c('div',[_vm._v("Add Product")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }